<template>
  <div class="row primary-filter" >
    <div class="col-md-auto filter-grid">
      <ul class="inlinelist">
        <li class="app-side-menu" v-if="hideMenu">
          <span @click="openMenu" class="pointer">
              <svgicon name="menu" width="20" height="20" :original="true" class="menu" />
              </span>
          <div class="sidemenu-slideout" :class="{ isOpen: isOpen }">
            <Sidebar v-on:close="onCloseMenu" />
          </div>
        </li>
        <li class="color-changes category">
          <FilterDropdown v-if="options.length"
                          :options="options"
                          :selected="seletedOption"
                          v-on:updateOption="onChangeOption" />
          <div class="selected-text" v-if="title">{{title}}</div>
        </li>
      </ul>
    </div>
    <div class="col filter-grid">
      <div class="row">
        <div class="col pr-0" v-if="!hideSearch.includes(this.currentRoute)">
          <div class="app-search-label" @click="setSearchGA('search')">
            <svgicon name="search" width="18" height="18" :original="true" />
            <span class="">
          <input :placeholder="placeholder" v-on:keyup="search" v-model="query">
        </span>
          </div>
        </div>
        <div class="col-md-auto" v-if="!hideOutSearch">
            <MdmSearch
            :multiFilter="multiFilter.includes(this.currentRoute)"
            :filterList="filterList"
            :filterTitle="filterTitle"
            :subFilterList="subFilterList"
            :subFilterTitle="subFilterTitle"
            :searchBy = "searchTerm"
            @searchTermChange="searchTermChange"
            @filterChange="filterChange"
            @subFilterChange="subFilterChange"
            @setFilterGA="setSearchGA('filter icon')"/>
        </div>
      </div>
    </div>
    <div class="col-md-auto filter-grid filter-button">
      <ul class="filter-btn-group inlinelist">
        <li v-if="showRateCalculator">
          <button class="btn btn-primary" @click="$emit('rateCalculator')">{{$t('MDM_RATE_CALCULATOR')}}</button>
        </li>
        <li v-if="rejectDownload">
          <button class="btn btn-secondary" @click="$emit( rejectEvent ? rejectEvent : 'rejectDownload')">{{$t('MDM_REJECTED_LIST')}}</button>
        </li>
        <li v-if="enableIt('create') && !hideAdd.includes(this.currentRoute)">
          <button class="btn btn-primary" @click="setGA('add');$emit('add')">{{$t('MDM_ADD')}}</button>
        </li>
        <li v-if="showStop.includes(this.currentRoute)">
          <button class="btn btn-primary" @click="setGA('stop');$emit('stop')">{{$t('MDM_STOP')}}</button>
        </li>
        <li v-if="enableIt('export') && !hideExport.includes(currentRoute)">
         <button  v-if="enableIt('export') && !isDropdownExport" class="btn btn-secondary"
          @click="setGA('export');$emit('export')">{{$t('MDM_EXPORT')}}</button>
        <Dropdown v-else-if="isDropdownExport" trigger="click" :class="{dropdownbutton : dropdownExportOpen}">
            <button type="primary" class="btn btn-secondary" @click="dropdownExportOpen = !dropdownExportOpen">
                {{$t('MDM_EXPORT')}}
                <svgicon name="categorydropdown"
                class="dropdown-icon"
                width="10" height="10"
                :original="true" />
              </button>
            <Dropdown-menu slot="dropdown">
              <Dropdown-item v-for="(data, idx) in getExportDropDownData" :key="`export-${data.name}-${idx}`">
                <div v-if="$hasPermission(data.permission)">
                  <label>
                   <span class="action" @click="setGA('export');$emit('export',data.name)"  >
                     {{$t(data.label)}}</span>
                    </label>
                     <a
                  href="javascript:void(0)"
                  @click="getExcelFormat"
                  v-if="getExcelFromAPI"
                  class="format-text" />
                  </div>
              </Dropdown-item>
            </Dropdown-menu>
          </Dropdown>
        </li>
        <li v-if="enableIt('import') && !hideBulk.includes(currentRoute)">
          <!-- //MDM Bulk Upload V2 Changes  -->
            <button
            v-if="seletedOption && seletedOption.is_bulk_upload_v2"
            type="primary" class="btn btn-secondary" @click="routeToMdmUploadPage()">
                {{$t('MDM_UPLOAD')}}
            </button>
              <!-- //MDM Bulk Upload V2 Changes  -->
              <!-- //MDM Bulk Upload V2 Changes afte update all masterwe need delete under lines -->
          <Processing v-if="isUploading" background="#0073FF" size="30px" />
          <Dropdown v-if="!seletedOption.is_bulk_upload_v2 && !isUploading" trigger="click" :class="{dropdownbutton : dropdownOpen}">
            <button type="primary" class="btn btn-secondary" @click="dropdownOpen = !dropdownOpen">
                {{$t('MDM_UPLOAD')}}
                <svgicon name="categorydropdown"
                class="dropdown-icon"
                width="10" height="10"
                :original="true" />
              </button>
            <Dropdown-menu slot="dropdown">
              <Dropdown-item>
                <label>
                  <input class="upload-material" type="file" id="file" ref="file"
                         :accept="`${AttachmentConstants.excelMimes}`"
                  v-on:change="handleFileUpload"/>
                    <span class="action" @click="setGA('bulk upload')">{{$t('MDM_BULK_UPLOAD')}}</span>
                </label>
                <a :href="`${$asset_path}static/sample/${sampleFileName}`"
                   v-if="sampleFileName.length" download
                   class="format-text"
                   target="_blank">
                    <span class="divided"></span>
                    <span @click="setGA('sample upload link')">{{$t('MDM_SAMPLE_FORMAT')}}</span></a>
                <a
                  href="javascript:void(0)"
                  @click="getExcelFormat"
                  v-if="getExcelFromAPI"
                  class="format-text">{{$t('MDM_SAMPLE_FORMAT')}}</a>
              </Dropdown-item>
              <Dropdown-item v-for="(upload, idx) in additionalUploads" :key="`additional-upload-key-${idx}`">
                <label>
                  <input class="upload-material" type="file" :id="`additional-upload-${idx}`" :ref="`additionalUpload${idx}`"
                         :accept="`${AttachmentConstants.excelMimes}`"
                  v-on:change="handleAdditionalFileUpload(upload.eventName, `additionalUpload${idx}`)"/>
                    <span class="action" @click="setGA(`${upload.name} upload`)">{{ upload.tlabel? $t(upload.tlabel): upload.name }}</span>
                </label>
                <a :href="`${$asset_path}static/sample/${upload.sampleFileName}`"
                  v-if="sampleFileName.length" download
                   class="format-text"
                   target="_blank">
                    <span class="divided"></span>
                    <span @click="setGA('sample upload link')">{{$t('MDM_SAMPLE_FORMAT')}}</span></a>
              </Dropdown-item>
            </Dropdown-menu>
          </Dropdown>
        </li>

      </ul>
    </div>
  </div>

</template>
<script>
import debounce from 'debounce';
import Sidebar from '@/components/common/Sidebar';
import MdmSearch from '@/components/common/app-search';
import FilterDropdown from '@common/components/FilterDropdown';
import AttachmentConstants from '@common/constants/AttachmentConstants';
import { bfrMapper } from '../../constants/mdm-v2/pageConstants';

export default {
  name: 'PrimaryFilter',
  components: {
    Sidebar,
    FilterDropdown,
    MdmSearch,
  },
  props: {
    placeholder: {
      type: String,
    },
    hideMenu: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    filterTitle: {
      type: String,
      default: 'Status',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    searchTerm: {
      type: Array,
      default: () => ([]),
    },
    subFilterTitle: {
      type: String,
      default: '',
    },
    subFilterList: {
      type: Array,
      default: () => ([]),
    },
    filterList: {
      type: Array,
      default: () => ([]),
    },
    seletedOption: {
      type: Object,
    },
    showExport: {
      type: Boolean,
      default: true,
    },
    isUploading: {
      type: Boolean,
      default: false,
    },
    sampleFileName: {
      type: String,
      default: '',
    },
    rejectDownload: {
      type: Number,
      default: 0,
    },
    resetSearch: {
      type: Boolean,
      default: true,
    },
    hideOutSearch: {
      type: Boolean,
      default: false,
    },
    rejectEvent: {
      type: String,
      default: null,
    },
    additionalUploads: {
      type: Array,
      default: () => ([]),
    },
    getExcelFromAPI: {
      type: Boolean,
      default: false,
    },
    defaultQuery: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      s3URL: process.env.VUE_APP_S3_PATH,
      isOpen: false,
      query: null,
      hideBulk: [],
      multiFilter: ['consignee', 'vendordepots', 'transporter', 'material', 'contract', 'vehicle', 'loading', 'sla', 'bdr', 'user'],
      hideSearch: ['exceptions', 'bdr_history', 'ratelookup', 'riq', 'riqdetail'],
      hideExport: ['role', 'transit_management', 'ratelookup'],
      hideAdd: ['contract', 'detention', 'role', 'transit_management', 'blacklist_vehicle', 'blacklist_driver', 'purchase_order', 'ratelookup'],
      showStop: ['bdr'],
      dropdownData: [
        {
          id: 0, name: 'depot', label: 'Depot details', permission: 'export_depot', type: 'depot',

        },
        {
          id: 1, name: 'gate', label: 'Gate details', permission: 'export_gate', type: 'depot',
        },
        {
          id: 2, name: 'purchase_order', label: 'Purchase Order details', permission: 'export_purchase_order', type: 'purchase_order',
        },
        {
          id: 3, name: 'utilization', label: 'Utilization Report', permission: 'export_purchase_order', type: 'purchase_order',
        },
      ],
      currentRoute: '',
      dropdownOpen: false,
      dropdownExportOpen: false,
      AttachmentConstants,
    };
  },

  created() {
    this.currentRoute = this.$router.history.current.name.toLowerCase();
    this.query = this.defaultQuery || null;
  },
  watch: {
    resetSearch() {
      this.query = '';
    },
  },
  computed: {
    showRateCalculator() {
      return this.currentRoute === 'contract' && this.$hasPermission('view_rate_calculator');
    },
    isDropdownExport() {
      if (this.currentRoute === 'depot') {
        return this.$hasPermission(`export_${this.currentRoute}`) || this.$hasPermission('export_gate');
      }
      return ['depot', 'purchase_order'].includes(this.currentRoute) && this.$hasPermission(`export_${this.currentRoute}`);
    },
    getExportDropDownData() {
      return this.dropdownData.filter(el => el.type === this.currentRoute);
    },

  },
  methods: {
    routeToMdmUploadPage() {
      const routerName = bfrMapper[this.$router.history.current.name] || this.$router.history.current.name;
      localStorage.setItem('mdm-upload-section', routerName);
      this.$router.push({ name: 'Upload',
        params: {
          previousRoute: routerName,
          type: 'mdm', // or anything you want,
        } });
    },
    enableIt(section) {
      // const route = (this.currentRoute) ? this.currentRoute : 'default';
      let route = (this.currentRoute) ? this.currentRoute : 'default';
      // if (route === 'depot') {
      //   return this.$hasPermission('export_depot') || this.$hasPermission('export_gate')
      // }
      switch (this.currentRoute) {
        case 'vendordepots': {
          route = 'depot';
          break;
        }
        default:
      }
      return this.$hasPermission(`${section}_${route}`);
    },
    getExcelFormat() {
      this.$emit('getExcel');
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.$emit('bulkUpload', this.file);
      // Reset the uploaded file value
      const input = this.$refs.file;
      input.type = 'file';
    },

    handleAdditionalFileUpload(eventName, refName) {
      this.file = this.$refs[refName][0].files[0];
      this.$emit(eventName, this.file);
      // Reset the uploaded file value
      const input = this.$refs[refName][0];
      input.type = 'file';
    },

    onChangeOption(data) {
      if (this.currentRoute === 'OutboundIndentsV2'
      || this.currentRoute === 'InboundIndentsV2') {
        this.$emit('change', data);
      } else if (this.currentRoute === 'Invoice') {
        this.$emit('selectedType', data);
      } else {
        const routerId = bfrMapper[data.id] || data.id;
        this.$router.push({ name: routerId });
      }
    },

    onCloseMenu() {
      this.isOpen = false;
    },

    openMenu: function open() {
      this.isOpen = true;
    },
    searchTermChange(data) {
      this.$emit('changeSearchTerm', data);
    },
    filterChange(data) {
      this.$emit('changeSearchTerm', { query: data, column: 'status' });
    },
    subFilterChange(data, type = null) {
      const column = type || data.type;
      this.$emit('changeSearchTerm', { query: data.id, column });
    },
    search: debounce(function debounceSearch() {
      const query = this.query;
      this.$emit('search', query);
    }, 500),
    setGA(section) {
      const currentRouteName = this.getCurrentSectionName();
      const event = `${currentRouteName} ${section} button`;
      this.$addGAEvent('MDM', 'Click', event);
    },
    setSearchGA(section) {
      const currentRouteName = this.getCurrentSectionName();
      const event = `${currentRouteName} ${section}`;
      this.$addGAEvent('MDM', section, event);
    },
    getCurrentSectionName() {
      return this.$router.history.current.meta.title;
    },
  },
};

</script>
<style scoped lang="scss">

</style>
